// Implements: F-IDN-014
/** The header row of the two-step card: its title and the state badge on the right (v3 `tf-t`). */

import type { ReactElement, ReactNode } from "react";

import { useTranslation } from "../../../shared/i18n";
import shared from "./account.module.css";

export interface TotpHeaderProps {
  readonly titleId: string;
  readonly badge: ReactNode;
}

export function TotpHeader({ titleId, badge }: TotpHeaderProps): ReactElement {
  const { t } = useTranslation();
  return (
    <div className={shared.head}>
      <h2 className={shared.title} id={titleId}>
        {t("account.totp.title")}
      </h2>
      {badge}
    </div>
  );
}
